import useDocumentTitle from '@/components/ui/common/document-title';
import FacilityScheduleTable from './table';
import { Card } from '@/components/ui/card';

const FacilitySchedule = () => {
  useDocumentTitle("Facilities Schedule");

  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <FacilityScheduleTable />
      </Card>
    </div>
  )
}

export default FacilitySchedule;